import React from 'react';
export function PageLoadingFallback() {
  return <div className="min-h-[60vh] flex flex-col items-center justify-center bg-slate-50" data-id="element-16483">
      {/* Animated cosmic loader */}
      <div className="relative w-16 h-16 mb-6" data-id="element-16484">
        {/* Outer ring */}
        <div className="absolute inset-0 rounded-full border-2 border-indigo-200" style={{
        animation: 'spin 3s linear infinite'
      }} data-id="element-16485" />
        {/* Middle ring */}
        <div className="absolute inset-2 rounded-full border-2 border-transparent border-t-indigo-400 border-r-indigo-400" style={{
        animation: 'spin 1.5s linear infinite reverse'
      }} data-id="element-16486" />
        {/* Inner pulsing core */}
        <div className="absolute inset-4 rounded-full bg-gradient-to-tr from-indigo-500 to-purple-500" style={{
        animation: 'pulse 2s ease-in-out infinite'
      }} data-id="element-16487" />
        {/* Glow */}
        <div className="absolute inset-3 rounded-full bg-indigo-400/20 blur-md" style={{
        animation: 'pulse 2s ease-in-out infinite'
      }} data-id="element-16488" />
      </div>

      <p className="text-sm text-slate-400 font-medium tracking-wide" data-id="element-16489">
        Загрузка...
      </p>

      <style data-id="element-16490">{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>;
}